export default {
   data() {
      return {
         setCurrentNavBar: this.$vnode.key,
         stationAlerts: null
      }
   },
   methods: {
      /* Simulates a click on the div="page" of the parent to close the Swisscom Side Menu, since it doesn't
    automatically closes after a navigation (yet) */
      closeMenu() {
         this.$parent.$refs.page.click()
      }
   },
   mounted() {},
   updated() {}
}
